import React from 'react'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from 'react-router-dom';
// import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
// import { blue, red } from '@mui/material/colors';
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import MailIcon from "@mui/icons-material/Mail";
// import PeopleIcon from "@mui/icons-material/People";
// import ApartmentIcon from "@mui/icons-material/Apartment";
import PersonIcon from '@mui/icons-material/Person';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import avtar from "../../../MobileScreens/assets/images/Profile-Picture.jpg";

function MobileVisitorDetails() {
    const navigate = useNavigate();
  return (
    <div className='mainWrapperView'>
    <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
        className="backArrowMobil"
        onClick={() => navigate("/Visitor")}
        />
        <h1>Visitor Details</h1>
    </div>
    <div className='topSpace'></div>
    <div className='SpecificSpMainDiv'>
      <div className="wraperMobile">
        <div className="sectionMobile">
          <div className="mobProHed">
            <div className="mobProHedInr">
              <div className="mobProHedInrProOut">
                <div className="mobProHedInrProFilePic">
                  <img src={avtar} alt="altimg"/>
                </div>
              </div>
              <h1>Namrata Patil</h1>
            </div>
          </div>
        </div>

        <div className="sectionMobile">
          <div className="mobProDetailsMain">
            <h1 className="mobContMainHeading">Details</h1>
            <div>
              <div className="mobProDetaiInr">
                <LocalPhoneIcon /> <span>8830789836</span>
              </div>
              <div className="mobProDetaiInr">
                <MailIcon /> <span>namratap.supra@gmail.com</span>
              </div>
              <div className="mobProDetaiInr">
                <ContactSupportIcon /> <span>Amezon Delivery</span>
              </div>
              <div className="mobProDetaiInr">
                <PersonIcon />{" "}
                <span>
                  Delivery Person/ Guest
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default MobileVisitorDetails